import { Card, Divider } from '@mui/material'
import React from 'react'
import Button from '../Button'
import cssClasses from './TokenBookingCard.module.css'
import routeImg from '../../Assets/Images/Dashboard/routeImg.png'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

export default function TokenBookingCard({ icon, tokenTitle,bookingTitle, tokenNumber,bookingNumber, selectedProject, showViewDetails, viewDetailsClicked }) {

    return (
      <Card
        style={{
          padding: showViewDetails ? "2rem 2rem 0 2rem" : "2rem 2rem 2rem 2rem",
        }}
        className={cssClasses.cardWrapper}
      >
        <div style={{ display: "flex", justifyContent: "space-between",gap:"1rem" }}>
          {icon && <img className={cssClasses.icon} src={icon} alt="" />}
          {selectedProject && (
            <img
              style={{ width: "3rem", height: "2rem" }}
              src={routeImg}
              alt=""
            />
          )}
          <p
            style={{
              fontSize: "1.6rem",
              whiteSpace: "nowrap",
              display: "flex",
              alignItems: "center",
              textWrap:"wrap"
            }}
            className={cssClasses.title}
          >
            {tokenTitle}
          </p>
        </div>
        <div style={{display:"flex",justifyContent:"space-between"}}> 
          <div>
            <p className={cssClasses.number}>{tokenNumber}</p>
            <p style={{fontSize:"1.4rem"}}>Tokens</p>
          </div>
          <div style={{border:"1px solid rgba(227, 227, 227, 1)"}}/>
          <div>
            <p className={cssClasses.number}>{bookingNumber}</p>
            <p style={{fontSize:"1.4rem"}}>Booked</p>
          </div>
        </div>
      </Card>
    );
}
